import { buildLanguageData } from '../buildLanguageData';
import CONTENT_TEMPLATE from './content_template.json';

/**
 * @const SPANISH_LANGUAGE
 * @description Language data for Spanish
 * @comment ADD NEW NAMESPACES HERE
 */
export const SPANISH_LANGUAGE = buildLanguageData({
    language: 'es',
    name: 'Español',
    namespaces: {
        blasts: {},
        campaign: {},
        cloud_function: {},
        common: {},
        content_template: CONTENT_TEMPLATE,
        country: {},
        database_entity: {},
        design_system: {},
        frontend: {},
        goals: {},
        graphql_route: {},
        insights: {},
        login: {},
        message_template: {},
        microsite: {},
        network: {},
        outbound_oauth: {},
        payments: {},
        people: {},
        settings: {},
        sidebar: {},
        sites: {},
        sms: {},
        stories: {},
        testing: {},
        widgets: {},
    },
});
